import { useGetStationData } from '@/hooks/use-get-data';

const useStationDrawerData = (stationId: string | null) => {
  const { data: stationData, isLoading } = useGetStationData({ id: stationId, enabled: true });

  return { stationData, isStationDataLoading: isLoading };
};

export default useStationDrawerData;
